(function () {
  document.querySelectorAll('.blog-references').forEach(function (block) {
    const content = block.querySelector('.blog-references--content');
    const fade = block.querySelector('.blog-references--fade');
    const topToggle = block.querySelector('.blog-references--toggle-top');
    const bottomToggle = block.querySelector('.blog-references--toggle-bottom');
    const bottomText = block.querySelector('.blog-references--toggle-text');

    if (!content) return;

    // 1) Start in collapsed state so CSS clamping is applied before measuring.
    block.setAttribute('data-collapsed', 'true');

    // Force a reflow so clientHeight reflects clamped layout.
    // (Any read like offsetHeight triggers it.)
    void content.offsetHeight;

    const hasOverflow = () => content.scrollHeight > content.clientHeight + 2;

    const setLabels = () => {
      const collapsed = block.getAttribute('data-collapsed') === 'true';
      if (bottomText) bottomText.textContent = collapsed ? 'Show all' : 'Show fewer';
      block.setAttribute('aria-expanded', String(!collapsed));
    };

    // 2) If there’s no overflow when collapsed, hide controls and un-collapse forever.
    if (!hasOverflow()) {
      if (fade) fade.style.display = 'none';
      if (topToggle) topToggle.style.display = 'none';
      if (bottomToggle) bottomToggle.style.display = 'none';
      block.removeAttribute('data-collapsed'); // nothing to toggle
      block.removeAttribute('aria-expanded');
      return;
    }

    // 3) There is overflow: show labels and wire up toggles.
    setLabels();

    function toggleState(e) {
      if (e) e.preventDefault();
      const collapsed = block.getAttribute('data-collapsed') === 'true';
      block.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      setLabels();
    }

    if (topToggle) topToggle.addEventListener('click', toggleState);
    if (bottomToggle) bottomToggle.addEventListener('click', toggleState);

    // 4) (Nice-to-have) Re-evaluate on resize in case lines wrap differently.
    let rAF;
    const onResize = () => {
      cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(() => {
        // Ensure collapsed before measuring
        block.setAttribute('data-collapsed', 'true');
        void content.offsetHeight;
        const overflow = hasOverflow();
        const display = overflow ? '' : 'none';
        if (fade) fade.style.display = display;
        if (topToggle) topToggle.style.display = display;
        if (bottomToggle) bottomToggle.style.display = display;
        if (!overflow) {
          block.removeAttribute('data-collapsed');
          block.removeAttribute('aria-expanded');
        } else {
          setLabels();
        }
      });
    };
    window.addEventListener('resize', onResize, { passive: true });
  });
})();